import type { core } from '@musinsa/pbo-core'

const TEXT_COLUMN_WIDTH = 130
const QUANTITY_COLUMN_WIDTH = 130

export const formatQuantity = (value: unknown): string => (value == null || value === '' ? '' : Number(value).toLocaleString())

export const textColumn = <T,>(dataIndex: keyof T & string, title: string, width = TEXT_COLUMN_WIDTH): core.CoreColumnType<T> => ({
  dataIndex,
  title,
  width,
})

export const quantityColumn = <T,>(dataIndex: keyof T & string, title: string): core.CoreColumnType<T> => ({
  dataIndex,
  title,
  width: QUANTITY_COLUMN_WIDTH,
  align: 'right',
  filterType: 'number',
  render: (value: unknown) => formatQuantity(value),
})
